import {
  LIST_PACKAGE_ADDITIONAL_INFO_REQUEST,
  LIST_PACKAGE_ADDITIONAL_INFO_SUCCESS,
  LIST_PACKAGE_ADDITIONAL_INFO_FAILURE,
  LIST_PACKAGE_ADDITIONAL_INFO_SUMMARY_REQUEST,
  LIST_PACKAGE_ADDITIONAL_INFO_SUMMARY_SUCCESS,
  LIST_PACKAGE_ADDITIONAL_INFO_SUMMARY_FAILURE,
  CREATE_PACKAGE_ADDITIONAL_INFO_REQUEST,
  CREATE_PACKAGE_ADDITIONAL_INFO_SUCCESS,
  CREATE_PACKAGE_ADDITIONAL_INFO_FAILURE,
  DETAIL_PACKAGE_ADDITIONAL_INFO_REQUEST,
  DETAIL_PACKAGE_ADDITIONAL_INFO_SUCCESS,
  DETAIL_PACKAGE_ADDITIONAL_INFO_FAILURE,
  UPDATE_PACKAGE_ADDITIONAL_INFO_REQUEST,
  UPDATE_PACKAGE_ADDITIONAL_INFO_SUCCESS,
  UPDATE_PACKAGE_ADDITIONAL_INFO_FAILURE,
  DELETE_PACKAGE_ADDITIONAL_INFO_REQUEST,
  DELETE_PACKAGE_ADDITIONAL_INFO_SUCCESS,
  DELETE_PACKAGE_ADDITIONAL_INFO_FAILURE
} from '../../constants/package-additional-info'

const initialState = {
  loading: false,
  packageAdditionalInfos: [],
  packageAdditionalInfo: {},
  packageAdditionalInfoSummary:[],
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const packageAdditionalInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_PACKAGE_ADDITIONAL_INFO_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_PACKAGE_ADDITIONAL_INFO_SUCCESS:
      return {
        ...state,
        loading: false,
        packageAdditionalInfos: action.payload,
        pageable: action.pageable
      }
    case LIST_PACKAGE_ADDITIONAL_INFO_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case LIST_PACKAGE_ADDITIONAL_INFO_SUMMARY_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_PACKAGE_ADDITIONAL_INFO_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        packageAdditionalInfoSummary: action.payload
      }
    case LIST_PACKAGE_ADDITIONAL_INFO_SUMMARY_FAILURE:
      return {
        ...state,
        loading: false,
        packageAdditionalInfoSummary: [],
        error: action.payload
      }
    case CREATE_PACKAGE_ADDITIONAL_INFO_REQUEST:
      return {
        ...state,
        loadingCreate: true
      }
    case CREATE_PACKAGE_ADDITIONAL_INFO_SUCCESS:
      return {
        ...state,
        loadingCreate: false
      }
    case CREATE_PACKAGE_ADDITIONAL_INFO_FAILURE:
      return {
        ...state,
        loadingCreate: false,
        error: action.payload
      }
    case DETAIL_PACKAGE_ADDITIONAL_INFO_REQUEST:
      return {
        ...state,
        loadingDetail: true
      }
    case DETAIL_PACKAGE_ADDITIONAL_INFO_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        packageAdditionalInfo: action.payload
      }
    case DETAIL_PACKAGE_ADDITIONAL_INFO_FAILURE:
      return {
        ...state,
        loadingDetail: false,
        error: action.payload
      }
    case UPDATE_PACKAGE_ADDITIONAL_INFO_REQUEST:
      return {
        ...state,
        loadingUpdate: true
      }
    case UPDATE_PACKAGE_ADDITIONAL_INFO_SUCCESS:
      const packageAdditionalInfoPayloadUpdate = action.payload
      const packageAdditionalInfoIdUpdate = action.packageAdditionalInfoId

      const packageAdditionalInfosUpdate = [...state.packageAdditionalInfos]
      const packageAdditionalInfoIndexUpdate = packageAdditionalInfosUpdate.findIndex(packageAdditionalInfo => packageAdditionalInfo.id === packageAdditionalInfoIdUpdate)
      packageAdditionalInfosUpdate[packageAdditionalInfoIndexUpdate] = packageAdditionalInfoPayloadUpdate

      return {
        ...state,
        loadingUpdate: false,
        packageAdditionalInfos: packageAdditionalInfosUpdate
      }
    case UPDATE_PACKAGE_ADDITIONAL_INFO_FAILURE:
      return {
        ...state,
        loadingUpdate: false,
        error: action.payload
      }
    case DELETE_PACKAGE_ADDITIONAL_INFO_REQUEST:
      return {
        ...state,
        loadingDelete: true
      }
    case DELETE_PACKAGE_ADDITIONAL_INFO_SUCCESS:
      const packageAdditionalInfoIdDelete = action.payload
      const packageAdditionalInfosDelete = [...state.packageAdditionalInfos]
      const packageAdditionalInfoIndexDelete = packageAdditionalInfosDelete.findIndex(packageAdditionalInfo => packageAdditionalInfo.id === packageAdditionalInfoIdDelete)
      packageAdditionalInfosDelete.splice(packageAdditionalInfoIndexDelete, 1)

      return {
        ...state,
        loadingDelete: false,
        packageAdditionalInfos: packageAdditionalInfosDelete
      }
    case DELETE_PACKAGE_ADDITIONAL_INFO_FAILURE:
      return {
        ...state,
        loadingDelete: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default packageAdditionalInfoReducer